//文字コードはutf-8

/* 無限横スクロール（マーキー）
 * .topFlowSlide__list の子要素を 1 セット分だけ複製し、
 * 親トラックを CSS keyframe で 50% 横移動させてシームレスループを実現する。
 *
 * - 元のリストを変えず、複製要素には aria-hidden を付けて読み上げ重複を防ぐ
 * - hover で一時停止（CSS 側）
 * - prefers-reduced-motion: reduce では複製もアニメーションもしない
========================================================*/

const REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

export function initMarquee() {
    const $lists = $('[data-marquee]');
    if (!$lists.length) return;

    if (REDUCED_MOTION) {
        // 静的表示のまま
        return;
    }

    $lists.each(function () {
        const $list = $(this);
        const $items = $list.children();

        // 1 件しかなければループ不可
        if ($items.length < 2) return;

        // 親に overflow: hidden の「ビューポート」を作る。
        // <ul> 自体に overflow: hidden を付けても content-sized なので
        // クリップ境界が動いてしまい、はみ出しが見えない。
        // そこで <div class="topFlowSlide__viewport"> を 1 段挟む。
        $list.wrap('<div class="topFlowSlide__viewport"></div>');

        // 同一セットを 1 回だけ複製（CSS keyframe は -50% で 1 サイクル）
        $items.clone(true)
            .attr('aria-hidden', 'true')
            .addClass('is-marqueeClone')
            .appendTo($list);

        // CSS アニメーション開始のためのクラスをトラックに付与
        $list.addClass('is-marquee');
    });
}
